module.exports = __webpack_public_path__ + "static/media/placeholderImageRecipe.fde084bf.jpg";